(function () {
  // main-product can include this asset more than once after section replacement.
  if (window.__bbPdpReviewAnchorInstalled) return;
  window.__bbPdpReviewAnchorInstalled = true;

  const ratingSelector = ".bb-product-detail__app-block .yotpo-sr-bottom-line-summary";
  const reviewsSelector = ".shopify-section:has(.yotpo-reviews-main-widget)";
  const scrollKeys = new Set(["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " ", "Escape"]);
  let cancelNavigation = () => {};

  function visibleHeaderHeight() {
    const header = document.querySelector(".section-header");
    if (!header) return 0;
    const rect = header.getBoundingClientRect();
    const style = getComputedStyle(header);
    return style.visibility !== "hidden" && style.display !== "none" &&
      rect.top <= 1 && rect.bottom > 0 ? rect.bottom : 0;
  }

  function navigateToReviews() {
    cancelNavigation();
    const controller = new AbortController();
    const startedAt = performance.now();
    let timer;
    let stopped = false;
    let previousTarget;
    let stableSince = startedAt;
    let scrolledAt;

    function stop() {
      stopped = true;
      clearTimeout(timer);
      controller.abort();
    }
    cancelNavigation = stop;

    // A correction belongs only to this click. Any new scrolling intent wins.
    for (const type of ["wheel", "touchstart", "pointerdown"]) {
      window.addEventListener(type, stop, { capture: true, passive: true, signal: controller.signal });
    }
    window.addEventListener("keydown", (event) => {
      if (scrollKeys.has(event.key)) stop();
    }, { capture: true, signal: controller.signal });
    window.addEventListener("pagehide", stop, { once: true, signal: controller.signal });

    function settle() {
      if (stopped) return;
      const now = performance.now();
      const reviewsSection = document.querySelector(reviewsSelector);
      const widget = reviewsSection?.querySelector(".yotpo-reviews-main-widget");
      if (widget && widget.getBoundingClientRect().height > 0) {
        const rect = reviewsSection.getBoundingClientRect();
        const gap = parseFloat(getComputedStyle(reviewsSection).scrollMarginTop) || 24;
        const maximum = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const target = Math.min(maximum, Math.max(0, window.scrollY + rect.top - visibleHeaderHeight() - gap));
        if (previousTarget === undefined || Math.abs(target - previousTarget) > 1) {
          stableSince = now;
          previousTarget = target;
        }

        if (scrolledAt === undefined && now - stableSince >= 150) {
          window.scrollTo({ top: target, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth" });
          scrolledAt = now;
        } else if (scrolledAt !== undefined && now - scrolledAt >= 600 &&
          now - stableSince >= 150 && Math.abs(window.scrollY - target) > 2) {
          // Related products, app content and reveal animations can move the
          // section after the first scroll. Re-measure rather than reuse a Y offset.
          window.scrollTo({ top: target, behavior: "instant" });
        }
      }

      // Do not leave observers/listeners maintaining a permanent scroll lock.
      if (now - startedAt >= 6000) stop();
      else timer = window.setTimeout(settle, 50);
    }
    settle();
  }

  // Capture before Yotpo's target/bubbling handlers so only one scroll owns
  // this rating activation. Other Yotpo controls retain their normal behaviour.
  window.addEventListener("click", (event) => {
    if (!(event.target instanceof Element) || !event.target.closest(ratingSelector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    navigateToReviews();
  }, true);
})();
